import { ReactNode, useEffect, useState } from "react";
import "./styles.scss";
import SideBar from "./side-bar/SideBar";
import BottomNav from "./bottom-bar/BottomNav";
import Header from "./header/Header";
import { SelectLanguage } from "./SelectLanguage";
import { useAppSelector } from "@/redux/hooks";
import { useLocation } from "react-router-dom";

export default function DashboardLayout({ children }: { children: ReactNode }) {
  const [LanguageModal, setLanguageModal] = useState<boolean>(false);
  const { loading } = useAppSelector((state) => state.languages);

  const location = useLocation();

  useEffect(() => {
    let selected = localStorage.getItem("selectedLanguage");
    if (location.pathname === "/activity") {
      if (selected === null) {
        setLanguageModal(true);
      }
    }
  }, [loading, location.pathname]);

  return (
    <div className="dashboard_layout--container">
      <SideBar />
      <BottomNav />
      <div className="right">
        <Header setModalState={setLanguageModal} modalState={LanguageModal} />
        <div className="dashboard-children">{children}</div>
      </div>
      {LanguageModal && <SelectLanguage setModalState={setLanguageModal} />}
    </div>
  );
}
